import { Component } from '@angular/core';

@Component({
  selector: 'app-wallet-sm',
  templateUrl: './wallet-sm.component.html',
  styleUrls: ['./wallet-sm.component.scss']
})
export class WalletSmComponent {

}
